import { z } from 'zod';
import { ImportFormatSchema } from '../import-export/envelopes.js';
import { LanguageSchema } from '../common/language.js';
import { ConsumableUnitSchema } from './units.js';
// Consumables wire requests — the STOCK dataset (import/export faces); the
// interactive transaction verbs + their bodies, when they land, extend this
// file.
// One stock-declaration row: "this place holds this quantity of this type."
// Location = the depot CODE (`warehouses.reference`) XOR the site reference (the
// site's storage row — born on demand under uq_whs_site); vehicle holds are not
// import-addressable at v1.
// The dataset maps a row to the ledger: no balance → receive · differing
// balance → adjust (count_correction, approve-gated) · equal → skip.
// `unit` guards existing types (mismatch = row error) and DEFINES the unit for
// a type born via vocabulary provisioning (consumable.types:manage).
export const ConsumableStockImportRowSchema = z
    .object({
    warehouse: z.string().trim().min(1).max(64).optional(),
    site: z.string().trim().min(1).max(32).optional(),
    type: z.string().trim().min(1).max(48),
    unit: ConsumableUnitSchema.optional(),
    quantity: z.number().min(0).max(999_999_999.999),
    effective_on: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/, 'expected YYYY-MM-DD')
        .optional(),
    note: z.string().trim().min(1).max(500).optional(),
})
    .strict();
// Stock export — current balances, reach-narrowed (warehouse:read at the
// route). Filters mirror what the balances surface will offer; the export is
// the current filtered truth (ADR-045 view-bound round-trip when the UI lands).
export const ExportConsumableStockQuerySchema = z
    .object({
    format: ImportFormatSchema.default('xlsx'),
    lang: LanguageSchema.default('en'),
    type: z.string().trim().max(48).optional(),
    warehouse_id: z.string().trim().min(1).max(16).optional(),
})
    .strict();
